export const SIGNUP_REVIEW_MODE = 'signup-review';
export const SIGNUP_REVIEW_MESSAGE_KIND = 'signup_review_invitation';
export const SIGNUP_REVIEW_PROMPT = 'Review my setup — what should I do next?';
export const SIGNUP_REVIEW_INTRO = 'Hello, I’m Counter Intelligence, your AI assistant for Countertop-App. I can answer questions and help execute many parts of your setup and day-to-day use. Would you like me to review your setup with you so you can continue getting the most from Countertop-App?';
export const SIGNUP_REVIEW_DISMISS_REPLY = 'No problem — I’ll be here whenever you’re ready.';

const REVIEW_CHOICE_KEY = 'signup_review_now';
const DISMISS_CHOICE_KEY = 'signup_review_later';

const CHOICES = Object.freeze([
  Object.freeze({ key: REVIEW_CHOICE_KEY, label: 'Yes, review my setup' }),
  Object.freeze({ key: DISMISS_CHOICE_KEY, label: 'Not now' }),
]);

export function signupReviewChoices() {
  return CHOICES.map((choice) => ({ ...choice }));
}

export function signupReviewChoiceAction(choice) {
  if (choice?.key === REVIEW_CHOICE_KEY) return 'review_setup';
  if (choice?.key === DISMISS_CHOICE_KEY) return 'dismiss';
  return null;
}

// The drawer's resting position is fixed against the right viewport edge. Its
// closed state is translated offscreen, so its measured left edge cannot be
// used to build the reverse of the existing panel-to-badge close animation.
// Work from its dimensions and the visible launcher's center instead.
export function drawerOpeningOffset({
  drawerWidth,
  drawerHeight,
  launcherRect,
  viewportWidth,
}) {
  const width = Number(drawerWidth);
  const height = Number(drawerHeight);
  const viewport = Number(viewportWidth);
  const left = Number(launcherRect?.left);
  const top = Number(launcherRect?.top);
  const launcherWidth = Number(launcherRect?.width);
  const launcherHeight = Number(launcherRect?.height);
  if (![width, height, viewport, left, top, launcherWidth, launcherHeight]
    .every(Number.isFinite)
    || width <= 0 || height <= 0 || viewport <= 0
    || launcherWidth <= 0 || launcherHeight <= 0) return null;

  const launcherCenterX = left + launcherWidth / 2;
  const launcherCenterY = top + launcherHeight / 2;
  const drawerCenterX = viewport - width / 2;
  const drawerCenterY = height / 2;
  return {
    x: Math.round(launcherCenterX - drawerCenterX),
    y: Math.round(launcherCenterY - drawerCenterY),
  };
}
